import StatusesForm from './StatusesForm';

export default StatusesForm;
